import { render } from "./MentorPairingList.vue?vue&type=template&id=a7b9e36e"
import script from "./MentorPairingList.vue?vue&type=script&lang=js"
export * from "./MentorPairingList.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3444732531/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__